import React from 'react'
import content from './content'
import AutoComplete from './AutoComplete'
import { Modules } from './Enums'
import Telephony from './Telephony'

export interface IDriftsInfo {
  module: 'telefoni' | 'bredbaand'
}

const DriftInfo = ({ module }: IDriftsInfo) => {
  const { BREDBAAND, TELEFONI } = Modules

  return (
    <>
      {module === TELEFONI && <Telephony />}
      {module === BREDBAAND && <AutoComplete content={content} />}
    </>
  )
}

export default DriftInfo
